module.exports = __webpack_public_path__ + "img/top.95a573b8.jpg";